import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/EditorPage.css';
import ChatBox from '../components/ChatBox';
import { baseUrl } from '../config';



const EditorPage = () => {
  const location = useLocation();
  const { file } = location.state || {};
  const [editorData, setEditorData] = useState(null);

  useEffect(() => {
    if (file) {
      // Placeholder for loading or initializing editor with the file
      setEditorData(`Editing ${file.name}`);
    }
  }, [file]);

  if (!file) {
    return <p>No file selected for editing</p>;
  }

  const handleSave = () => {
    // Implement save logic
  };

  const handleEffectApplied = (effect) => {
    // Implement the logic to handle the applied effect
  };

  return (
    <div className="editor-page">
      <h2>Editor Page</h2>
      <div className="file-preview">
        {file.imageUrl.endsWith('.pdf') ? (
          <div className="pdf-preview">
            {/* Implement PDF rendering logic */}
            <iframe
              src={file.imageUrl}
              title={file.name}
              width="600"
              height="500"
              className="pdf-viewer"
            />
          </div>
        ) : (
          <div className="video-preview">
            <video width="600" controls>
              <source src={file.imageUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
        <p className="file-name">{file.name}</p>
      </div>

      <div className="editor-controls">
        <p>{editorData}</p>
        <div className="editor-actions">
          <button className="action-button" onClick={() => console.log('Trim')}>
            Trim
          </button>
          <button className="action-button" onClick={() => console.log('Cut')}>
            Cut
          </button>
          <button className="action-button" onClick={() => console.log('Add Effect')}>
            Add Effect
          </button>
        </div>
        <button className="save-button" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      <ChatBox onEffectApplied={handleEffectApplied} />
    </div>
  );
};

export default EditorPage;

